
























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { uploadAddonValidate } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import { IAddonData } from "../../../../../config/newQuestionnaire";

@Component({
  name: "uploadAddon",
  components: {
    questionSettingTemplate,
  },
})
export default class uploadAddon extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  // isIndeterminatePic = false;
  // isIndeterminateFile = false;
  // isIndeterminateVideo = false;
  checkAllFile = false;
  checkAllPic = false;
  checkAllVideo = false;
  picTypes = [".png", ".jpg", ".jpeg", ".webp"];
  fileTypes = [".doc", ".docx", ".pdf", ".xls", ".xlsx", ".ppt", ".pptx"];
  videoTypes = [".mp4", ".mov"]; //苹果录制格式为mov
  private postForm: any = {
    title: "请选择以下选项", // 标题
    required: 1, // 是否必填
    uploadLimitCount: 1, // 是否必填
    jsonConfig: {
      subTitle: "",
      picTypes: [],
      fileTypes: [],
      videoTypes: [],
      showIndex: true,
      isIndeterminateFile: false,
      isIndeterminatePic: false,
      isIndeterminateVideo: false,
    },
  };

  private rules = {
    title: [{ required: true, message: "请输入标题", type: "string", trigger: "blur" }],

    required: [{ required: true, message: "请选择是否必填", trigger: "blur" }],
    uploadLimitCount: [{ required: true, message: "请填写上传文件数量", trigger: "blur" }],
    "jsonConfig.picTypes": [{ validator: this.validatorfileType, trigger: "blur" }],
  };
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    console.log("watchPostForm", backup);
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  validatorfileType(rule: any, value: string, callback: any) {
    if ((this.postForm.jsonConfig as any).picTypes.length == 0 && (this.postForm.jsonConfig as any).fileTypes.length == 0 && (this.postForm.jsonConfig as any).videoTypes.length == 0) {
      callback(new Error("请选择文件类型"));
    } else {
      callback();
    }
  }
  handleCheckAllChangePic(val: boolean) {
    this.postForm.jsonConfig.picTypes = val ? this.picTypes : [];
    this.postForm.jsonConfig.isIndeterminatePic = val;
  }
  handleCheckedChangePic(value: Array<string>) {
    let checkedCount = value.length;
    this.checkAllPic = checkedCount === this.picTypes.length;
    this.postForm.jsonConfig.isIndeterminatePic = checkedCount > 0 && checkedCount < this.picTypes.length;
  }
  handleCheckAllChangeFile(val: boolean) {
    this.postForm.jsonConfig.fileTypes = val ? this.fileTypes : [];
    this.postForm.jsonConfig.isIndeterminateFile = val;
  }
  handleCheckedCitiesChangeFile(value: Array<string>) {
    let checkedCount = value.length;
    this.checkAllFile = checkedCount === this.fileTypes.length;
    this.postForm.jsonConfig.isIndeterminateFile = checkedCount > 0 && checkedCount < this.fileTypes.length;
  }
  handleCheckAllChangeVideo(val: boolean) {
    this.postForm.jsonConfig.videoTypes = val ? this.videoTypes : [];
    this.postForm.jsonConfig.isIndeterminateVideo = val;
  }
  handleCheckedCitiesChangeVideo(value: Array<string>) {
    let checkedCount = value.length;
    this.checkAllVideo = checkedCount === this.videoTypes.length;
    this.postForm.jsonConfig.isIndeterminateVideo = checkedCount > 0 && checkedCount < this.videoTypes.length;
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }

  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
